<template>
  <v-card flat color="transparent" class="ma-0 pa-0">
    <v-parallax class="hero-image" :height="$vuetify.breakpoint.mobile ? 525 : 770" :src="$vuetify.breakpoint.mobile ? require('@/assets/images/ifpi-start-hero-mobile.jpg') : require('@/assets/images/ifpi-start-hero-desktop.jpg')">
      <div class="d-flex fill-height align-center justify-center">
        <v-card-title class="display-2 text-center hero-title" v-html="$t('start.title')"></v-card-title>
      </div>
    </v-parallax>
    <v-card-text>
      <v-row justify="center">
        <v-col cols="12">
          <p v-if="startContent && startContent.intro" class="start-intro mt-4 mx-auto">{{ startContent.intro }}</p>
        </v-col>
      </v-row>
      <v-row v-if="startContent && startContent.steps" justify="center" class="mt-4 steps-row">
        <v-col
          v-for="(step, i) in startContent.steps"
          :key="i"
          cols="12"
          sm="4"
        >
          <logged-out-step-card :step="step" />
        </v-col>
      </v-row>
      <v-row v-if="startContent && startContent.faq" justify="center" class="mt-8">
        <v-col cols="12" sm="10" md="8">
          <v-expansion-panels
            elevation="0"
            flat
            class="faq-panels"
          >
            <v-expansion-panel
              v-for="(item, i) in startContent.faq"
              :key="i"
            >
              <v-expansion-panel-header>{{ item.question }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-html="item.answer" style="display:block" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import LoggedOutStepCard from '@/components/LoggedOutStepCard.vue';

export default {
  name: 'LoggedOutStart',
  components: { LoggedOutStepCard },

  data: () => ({
    contentLocale: ''
  }),

  computed: {
    ...mapGetters('app', ['startContent', 'locale'])
  },

  mounted() {
    if (!this.startContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadStartContent', this.locale)
      this.contentLocale = this.locale
    }
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadStartContent', this.locale)
      this.contentLocale = this.locale
    }
  }

}
</script>

<style scoped>
.steps-row {
  max-width: 1200px;
  margin-left: auto !important;
  margin-right: auto !important;
}
.steps-row > .col {
  padding-left: 60px;
  padding-right: 60px;
}

.start-intro {
  font-family: 'DM Sans', sans-serif;
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
  max-width: 950px;
}
</style>

<style>
.v-expansion-panel-content__wrap {
  display: block !important;
}
.faq-panels {
  margin-bottom: 24px;
  max-width: 700px;
  margin-left: auto !important;
  margin-right: auto !important;
}
.faq-panels .v-expansion-panel-header,
.faq-panels .v-expansion-panel-content {
  font-size: 16px;
}
.faq-panels .v-expansion-panel-header {
  border-bottom: 2px solid var(--v-primary-base);
}
.faq-panels .v-expansion-panel-content__wrap {
  padding-top: 24px;
}
.faq-panels .v-expansion-panel,
.faq-panels .v-expansion-panel::before,
.theme--light .faq-panels .v-expansion-panel,
.theme--light .faq-panels.v-expansion-panels .v-expansion-panel {
  background-color: var(--color-primary-container) !important;
  background: var(--color-primary-container) !important;
}


</style>